import React from 'react';
import './Pricing.css';

const plans = [
  {
    name: 'Starter',
    amount: '₹1,999',
    period: 'per session',
    features: [
      '1 Instagram Reel (Upto 60 sec)',
      'Cinematic editing & colour',
      '1 revision round',
      'Delivered in 4 hours',
      '1 creator, 1 location',
    ],
    btnLabel: 'Book Starter',
    btnClass: 'pb-org',
    featured: false,
    delay: '',
  },
  {
    name: 'Pro',
    amount: '₹3,499',
    period: 'per session',
    popular: 'Most Popular',
    features: [
      '2 Reels',
      'Pro editing, music & captions',
      '1 revision round',
      'Delivered in 2 hours',
      '1 creators, 1 locations',
    ],
    btnLabel: 'Book Pro',
    btnClass: 'pb-wht',
    featured: true,
    delay: 'rd1',
  },
{
  name: 'Custom Package',
  amount: 'Flexible',
  period: 'tailored for your event',
  features: [
    'Personalized event coverage',
    'Choose your own reel style',
    'Flexible creator hours',
    'Custom add-ons & edits',
    'Suitable for all event types',
    'Premium cinematic delivery',
  ],
  btnLabel: 'Customize Now',
  btnClass: 'pb-outline',
  featured: false,
  delay: 'rd2',
},
];

const handleAnchorClick = (e, href) => {
  e.preventDefault();
  const target = document.querySelector(href);
  if (target) target.scrollIntoView({ behavior: 'smooth' });
};

const Pricing = () => (
  <section className="pricing" id="pricing">
    <div className="container">
      <div className="pricing-head reveal">
        <span className="sec-label">Simple pricing</span>
        <h2 className="sec-h2">No Surprises.<br />Just <em>Great Content.</em></h2>
        <p>Pick a plan and book your first GoSnap session today.</p>
      </div>
      <div className="pricing-grid">
        {plans.map((plan) => (
          <div key={plan.name} className={`price-card reveal ${plan.delay}${plan.featured ? ' featured' : ''}`}>
            {plan.popular && <div className="price-popular">{plan.popular}</div>}
            <div className="price-name">{plan.name}</div>
            <div className="price-amt">{plan.amount}</div>
            <div className="price-period">{plan.period}</div>
            <ul className="price-feats">
              {plan.features.map((f) => (
                <li key={f} className="price-feat-item">{f}</li>
              ))}
            </ul>
            <button
              className={`price-btn ${plan.btnClass}`}
              onClick={(e) => handleAnchorClick(e, '#contact')}
            >
              {plan.btnLabel}
            </button>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Pricing;
